module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mmcs"
  }, [_c('div', {
    staticClass: "mmcs-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn-mmcs-ls"
  }, [_c('div', {
    staticClass: "top-admin"
  }, [_c('i', {
    on: {
      "click": _vm.addModifyPassword
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.userInfo.account
    },
    on: {
      "click": _vm.addModifyPassword
    }
  }, [_vm._v(_vm._s(_vm.userInfo.account))])]), _vm._v(" "), _c('div', {
    staticClass: "top-exit",
    on: {
      "click": _vm.cancelLogin
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("退出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mmcs-bottom"
  }, [_c('div', {
    staticClass: "content-left-list"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "router": "",
      "default-active": "2"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [(_vm.page.page1) ? _c('el-menu-item', {
    class: {
      isActive: ('企业趋势' === _vm.showHide)
    },
    attrs: {
      "index": "/enterpriseTrend"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业趋势')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-1"
  }), _vm._v("企业趋势\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page2) ? _c('el-menu-item', {
    class: {
      isActive: ('企业统计' === _vm.showHide)
    },
    attrs: {
      "index": "/enterpriseStatistics"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业统计')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-2"
  }), _vm._v("企业统计\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page3) ? _c('el-menu-item', {
    class: {
      isActive: ('企业订单' === _vm.showHide)
    },
    attrs: {
      "index": "/enterpriseOrder"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业订单')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-3"
  }), _vm._v("企业订单\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page4) ? _c('el-menu-item', {
    class: {
      isActive: ('企业管理' === _vm.showHide)
    },
    attrs: {
      "index": "/enterpriseManage"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业管理')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-4"
  }), _vm._v("企业管理\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page5) ? _c('el-menu-item', {
    class: {
      isActive: ('企业网站' === _vm.showHide)
    },
    attrs: {
      "index": "/enterpriseWebsite"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业网站')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-5"
  }), _vm._v("企业网站\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page8) ? _c('el-menu-item', {
    class: {
      isActive: ('企业观察' === _vm.showHide)
    },
    attrs: {
      "index": "/companyObserve"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('企业观察')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-view"
  }), _vm._v("企业观察\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page6) ? _c('el-menu-item', {
    class: {
      isActive: ('系统设置' === _vm.showHide)
    },
    attrs: {
      "index": "/systemSetup"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('系统设置')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-6"
  }), _vm._v("系统设置\n          ")]) : _vm._e(), _vm._v(" "), (_vm.page.page7) ? _c('el-menu-item', {
    class: {
      isActive: ('后台设置' === _vm.showHide)
    },
    attrs: {
      "index": "/bgSet"
    },
    on: {
      "click": function($event) {
        return _vm.showListLiColor('后台设置')
      }
    }
  }, [_c('i', {
    staticClass: "left-list-font-7"
  }), _vm._v("后台设置\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-right-view"
  }, [_c('div', [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-mmcs-ls"
  }, [_c('div', {
    staticClass: "logo-mmcs-ls-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-mmcs-ls-r"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d81eb05","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 623
// module chunks = 1